export const BRAND_NAME = "Easter Wallpaper";
export const BRAND_SLUG = "easterwallpaper";
export const BRAND_TAGLINE =
  "Original Easter wallpapers for iPhone, desktop, cute spring themes, and Christian Easter collections";
export const VISIBLE_LOGO_SRC = "/imgs/logos/logo.png";
export const PRIMARY_DOMAIN = "easterwallpaper.lol";
export const PRIMARY_URL = `https://${PRIMARY_DOMAIN}`;
export const OPERATOR_NAME = "Easter Wallpaper Studio";
export const OPERATOR_URL = PRIMARY_URL;
export const SUPPORT_EMAIL = "hello@easterwallpaper.lol";
export const SUPPORT_MAILTO = `mailto:${SUPPORT_EMAIL}`;
